/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ScriptExecutionTargetDto } from './scriptExecutionTargetDto';


export interface ScriptExecutionTargetPageDto { 
    current_page_size?: number;
    page_number?: number;
    requested_page_size?: number;
    total_pages?: number;
    total_record_count?: number;
    /**
     * List of script execution target records
     */
    result?: Array<ScriptExecutionTargetDto>;
}

